export const changeProfile = (profile) => (dispatch) => {
    dispatch({
        type: 'USER_PROFILE_CHANGE',
        payload: profile
    })
    localStorage.setItem('activeProfile', profile)
}

export const changeMenu = (menu) => (dispatch) => {
    dispatch({
        type: 'USER_MENU_CHANGE',
        payload: menu
    })
    localStorage.setItem('activeMenu', menu)
}